import { render, staticRenderFns } from "./TablaSerie.vue?vue&type=template&id=603692dc&"
import script from "./TablaSerie.vue?vue&type=script&lang=ts&"
export * from "./TablaSerie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports